"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ResponsiveImage = void 0;
const components_core_1 = require("@volkswagen-onehub/components-core");
const react_1 = __importDefault(require("react"));
function createSrcSet(createImageUrl, widths) {
    return widths.map(width => `${createImageUrl(width)} ${width}w`).join(', ');
}
function createSizes(breakpointSizes) {
    return Object.entries(breakpointSizes)
        .sort(([breakpointA], [breakpointB]) => parseInt(breakpointB, 10) - parseInt(breakpointA, 10))
        .map(([breakpoint, size]) => breakpoint === String(components_core_1.Breakpoints.default)
        ? `${size}`
        : `(min-width: ${breakpoint}px) ${size}`)
        .join(', ');
}
exports.ResponsiveImage = react_1.default.memo(({ createImageUrl, defaultWidth, widths, breakpointSizes, alt, lazy }) => {
    const src = createImageUrl(defaultWidth);
    const srcSet = createSrcSet(createImageUrl, widths);
    const sizes = createSizes(breakpointSizes);
    return lazy ? (react_1.default.createElement(components_core_1.LazyImage, { alt: alt, src: src, srcSet: srcSet, sizes: sizes })) : (react_1.default.createElement(components_core_1.Image, { alt: alt, src: src, srcSet: srcSet, sizes: sizes }));
});
